import { render, staticRenderFns } from "./visAllPrevious.vue?vue&type=template&id=22da0b8c"
import script from "./visAllPrevious.vue?vue&type=script&lang=js"
export * from "./visAllPrevious.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports